<template>
  <div class="air-calendar__container w100 flex jbetween wrap">
    <month-calendar
      v-for="month in 12"
      :key="`month-${month}`"
      :month="month"
      :init-calendar="dateType"
      v-bind="$attrs"
      v-on="$listeners"
    >
    </month-calendar>
    <!-- 排版占位 -->
    <i></i>
    <i></i>
    <i></i>
    <i></i>
  </div>
</template>

<script>
import MonthCalendar from './MonthCalendar'

export default {
  name: 'airCalendar',
  components: { MonthCalendar },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
  },
  data () {
    return {
    }
  },
  computed: {
    dateType() {
      let obj = {}
      for (let dateObj of this.data) {
        obj[dateObj.date] = dateObj.type
      }
      return obj
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.air-calendar__container {
  i {
    width: 405px;
  }

  @media screen and (max-width:1850px) {
    justify-content: space-evenly;
  }
}
</style>
